module.exports = __webpack_public_path__ + "img/2-4.b6944d87.jpg";